import { gql } from "@apollo/client";

export const JOB_STATUS_QUERY = gql`
    query JobStatus($taskId: String!) {
        jobStatus(taskId: $taskId) {
            state
            percent
            processed
            total
            successful
            failed
            result {
                success
                successfulUploads
                failedUploads
                error
            }
        }
    }
`;
